import { render, staticRenderFns } from "./invitationInfo.vue?vue&type=template&id=e56a60bc&scoped=true&"
import script from "./invitationInfo.vue?vue&type=script&lang=js&"
export * from "./invitationInfo.vue?vue&type=script&lang=js&"
import style0 from "./invitationInfo.vue?vue&type=style&index=0&id=e56a60bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56a60bc",
  null
  
)

export default component.exports